import { useEffect, useRef } from "react"
import { Search, X } from "lucide-react"

/**
 * Die Suche der Mailliste: zugeklappt eine Lupe in Knopfgroesse, aufgeklappt
 * ein schmales Feld.
 *
 * Vorher stand hier ein 280px breiter Kasten mit dem Platzhalter „Betreff,
 * Body, E-Mail, Telefon, Rechnungs-Nr..." — der breiteste Griff in der Leiste
 * fuer den seltensten Handgriff, und er drueckte die Knoepfe daneben zusammen.
 *
 * Laeuft eine Suche, bleibt das Feld offen: ein Filter, der die Liste kuerzt,
 * darf sich nicht hinter einem Icon verstecken.
 */
export function ToolbarSearch({
  value, onChange, open, setOpen, isSearching,
}: {
  value: string
  onChange: (v: string) => void
  open: boolean
  setOpen: (v: boolean) => void
  /** Server-Volltextsuche laeuft (zeigt das „global"-Abzeichen). */
  isSearching?: boolean
}) {
  const ref = useRef<HTMLInputElement>(null)
  // Aufgeklappt heisst tippbereit — sonst waere die Lupe zwei Klicks statt einem.
  useEffect(() => {
    if (open) ref.current?.focus()
  }, [open])

  const zu = () => { onChange(""); setOpen(false) }

  if (!open && !value) {
    return (
      <button
        type="button"
        className="ev2-tb-btn icon"
        onClick={() => setOpen(true)}
        title="Suchen: Betreff, Body, Absender, Telefon, Rechnungs-Nr."
        aria-label="Suchen"
      >
        <Search className="w-[13px] h-[13px]" />
      </button>
    )
  }

  return (
    <div style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
      <Search
        className="w-[12px] h-[12px]"
        style={{ position: "absolute", left: 8, color: "var(--text-muted)", pointerEvents: "none" }}
      />
      <input
        ref={ref}
        className="ev2-tb-search"
        placeholder="Suchen…"
        aria-label="Suchbegriff"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Escape") zu() }}
        // Leer und aus dem Fokus: wieder zur Lupe. Mit Text bleibt es stehen.
        onBlur={() => { if (!value) setOpen(false) }}
        title="Sucht ueber Betreff, Body, Absender, Empfaenger und Entwuerfe in allen Ordnern. Mehrere Begriffe werden UND-verknuepft."
      />
      {value && (
        <button
          type="button"
          onClick={zu}
          title="Suche zuruecksetzen (Esc)"
          aria-label="Suche zuruecksetzen"
          style={{
            position: "absolute", right: 4, display: "inline-flex", alignItems: "center",
            background: "transparent", border: 0, cursor: "pointer",
            color: "var(--text-muted)", padding: 2, lineHeight: 1,
          }}
        >
          <X className="w-3 h-3" />
        </button>
      )}
      {isSearching && (
        <span
          style={{
            position: "absolute", right: 22,
            fontSize: 12, color: "var(--text-muted)", background: "rgba(0,0,0,0.04)",
            padding: "1px 6px", borderRadius: 999, pointerEvents: "none",
          }}
          title="Globale Volltext-Suche aktiv — Folder-Filter ausgeblendet"
        >
          global
        </span>
      )}
    </div>
  )
}
